import { CONTENT_SECTIONS } from '../sections';
import { INSURANCE_TYPES } from '../../constants';
import { petData } from '../../components/popular-products-section/data';
import type { ContentData } from './types';

const data: ContentData = {
  sections: [
    {
      ...petData,
      type: CONTENT_SECTIONS.POPULAR_PRODUCTS,
    },
  ],
  type: INSURANCE_TYPES.PET,
};

export default data;
